import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageTestComponent = () => {
  const { t, i18n } = useTranslation();

  const testKeys = [
    'serviceDetail.vipCar.vehicles.badge',
    'serviceDetail.vipCar.vehicles.title',
    'serviceDetail.vipCar.vehicles.subtitle',
    'serviceDetail.vipCar.vehicles.types.0.title',
    'serviceDetail.vipCar.vehicles.types.0.features.0'
  ];

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-6">多言語テスト - 車両ラインナップ</h1>
        
        <div className="mb-6">
          <h2 className="text-lg font-semibold mb-3">言語切替</h2>
          <div className="flex gap-4">
            <button 
              onClick={() => i18n.changeLanguage('ja')}
              className={`px-4 py-2 rounded ${i18n.language === 'ja' ? 'bg-blue-500 text-white' : 'bg-white border'}`}
            >
              日本語
            </button>
            <button 
              onClick={() => i18n.changeLanguage('en')}
              className={`px-4 py-2 rounded ${i18n.language === 'en' ? 'bg-blue-500 text-white' : 'bg-white border'}`}
            >
              English
            </button>
            <button 
              onClick={() => i18n.changeLanguage('th')}
              className={`px-4 py-2 rounded ${i18n.language === 'th' ? 'bg-blue-500 text-white' : 'bg-white border'}`}
            >
              ไทย
            </button>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold mb-4">翻訳テスト (現在の言語: {i18n.language})</h2>
          <div className="space-y-3">
            {testKeys.map((key) => (
              <div key={key} className="border-b border-gray-200 pb-2">
                <div className="text-sm text-gray-500 mb-1">{key}</div>
                <div className="font-medium">{t(key)}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-6">
          <a 
            href="/demo/vehicle-lineup" 
            className="inline-block bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition-colors"
          >
            車両ラインナップデモを見る
          </a>
        </div>
      </div>
    </div>
  );
};

export default LanguageTestComponent;
